import { LogOut, RefreshCw } from "lucide-react";

export const AdminHeader = ({ offen, total, loading, onRefresh, onLogout }) => (
    <header className="border-b border-[#DDD6C8] bg-[#F4F1EA]/95 backdrop-blur sticky top-0 z-10">
        <div className="max-w-4xl mx-auto px-5 sm:px-8 h-[68px] flex items-center justify-between">
            <div>
                <p className="font-serif text-xl text-[#2B2825]">Anfragen</p>
                <p className="font-sans text-[10px] tracking-[0.25em] uppercase text-[#8C8275]">
                    {total === null ? "…" : `${offen} offen · ${total} gesamt`}
                </p>
            </div>
            <div className="flex items-center gap-4">
                <button data-testid="admin-refresh" onClick={onRefresh} className="inline-flex items-center gap-1.5 font-sans text-xs text-[#59534C] hover:text-[#2B2825]">
                    <RefreshCw size={14} className={loading ? "animate-spin" : ""} /> Aktualisieren
                </button>
                <button data-testid="admin-logout" onClick={onLogout} className="inline-flex items-center gap-1.5 font-sans text-xs text-[#59534C] hover:text-[#2B2825]">
                    <LogOut size={14} /> Abmelden
                </button>
            </div>
        </div>
    </header>
);

export const FilterBar = ({ filter, setFilter, offen, done }) => {
    const FILTERS = [
        { key: "offen", label: `Offen (${offen})` },
        { key: "erledigt", label: `Beantwortet (${done})` },
        { key: "alle", label: "Alle" },
    ];
    return (
        <div data-testid="admin-filter" className="flex gap-2 flex-wrap">
            {FILTERS.map((f) => (
                <button
                    key={f.key}
                    data-testid={`admin-filter-${f.key}`}
                    onClick={() => setFilter(f.key)}
                    className={`font-sans text-[12px] tracking-[0.08em] px-4 py-2 border transition-colors ${
                        filter === f.key ? "bg-[#2B2825] border-[#2B2825] text-[#FAF8F5]" : "border-[#C8C0B0] text-[#59534C] hover:border-[#2B2825]"
                    }`}
                >
                    {f.label}
                </button>
            ))}
        </div>
    );
};
